import _ from 'lodash';
import React, { Fragment } from 'react';
import { Translate, useTranslate } from 'core/translate';
import { SvgIcon } from 'core/icons';
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  ModalFooterButtons,
  ModalFooterPrimaryButton,
  ModalFooterCancelButton
} from '../../common/modal/Modal';

const DimensionTable = ({ dimensions }) => {
  const dimensionRows = dimensions.map(dimension => {
    return (
      <tr key={dimension.id}>
        <td>{dimension.description}</td>
        <td>{dimension.value}</td>
      </tr>
    );
  });

  return (
    <table className="dimensions-table">
      <tbody>{dimensionRows}</tbody>
    </table>
  );
};

export const DimensionsBody = ({ bodyTypes, features, id }) => {
  try {
    const bodyType = _.find(bodyTypes, { id: id });

    const styleId = _.get(
      _.find(features.options, { bodyTypeId: id }),
      'styleId'
    );
    const groupsDimensions = features.groups.Dimensions;
    const styleDimensions = features.styleIds[styleId].Dimensions;
    const dimensions = _.keys(groupsDimensions).map(function(key) {
      return {
        id: key,
        description: groupsDimensions[key].description,
        value: styleDimensions[key]
      };
    });

    return (
      <Fragment>
        <div className="dimensions-header">
          <div className="dimensions-header__icon">
            <SvgIcon name={bodyType.icon} className={bodyType.iconClass} />
          </div>
          <div>
            <div>{bodyType.formattedConfig}</div>
            <div>{bodyType.rearWheelType}</div>
          </div>
        </div>
        <DimensionTable dimensions={dimensions} />
      </Fragment>
    );
  } catch (e) {
    return <Translate value="component.dimensions.error" />;
  }
};

const Dimensions = ({ features, id, bodyTypes, onClose }) => {
  const translate = useTranslate();
  const header = translate('component.dimensions.title');
  return (
    <Modal
      isOpen={true}
      className="reveal--narrow"
      contentLabel={header}
      onRequestClose={onClose}>
      <ModalHeader text={header} analyticsKey={header} onClose={onClose} />
      <ModalBody>
        <DimensionsBody bodyTypes={bodyTypes} features={features} id={id} />
      </ModalBody>
      <ModalFooter>
        <ModalFooterButtons>
          <ModalFooterCancelButton onClick={onClose} data-dtm={header} />
          <ModalFooterPrimaryButton onClick={onClose} data-dtm={header} />
        </ModalFooterButtons>
      </ModalFooter>
    </Modal>
  );
};

export default Dimensions;
